module.exports = __webpack_public_path__ + "media/images/bg/mosaic/hanami-78c3be56e02ee2eada5e5ffe5a96d866.jpg";